<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
@import './assets/css/icon.less';
#app {
  font-family: 'PingFang SC', PingHei, STHeitiSC-Light, 'Myriad Set Pro',
    'Lucida Grande', 'Helvetica Neue', Helvetica, 'microsoft yahei', SimHei,
    tahoma, Arial, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
html,
body {
  height: 100%;
}
* {
  padding: 0;
  margin: 0;
  font-size: 0.833vw;
}
.swiper-pagination-bullet {
  background-color: #fff !important;
}
.swiper-pagination-bullet-active {
  opacity: 1;
  background: #0092f3 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue